var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgO(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82.05 89.73"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.05 44.84c0 14.43-3.54 25.52-10.61 33.27-7.07 7.75-17.21 11.63-30.41 11.63s-23.34-3.88-30.41-11.63C3.54 70.35 0 59.22 0 44.72s3.55-25.59 10.64-33.24C17.73 3.83 27.9 0 41.14 0s23.37 3.86 30.38 11.57 10.52 18.8 10.52 33.27zm-62.89 0c0 9.74 1.83 17.07 5.48 22s9.12 7.39 16.39 7.39c14.58 0 21.87-9.8 21.87-29.39s-7.25-29.45-21.75-29.45c-7.27 0-12.75 2.47-16.44 7.42-3.69 4.95-5.54 12.29-5.54 22.03z",
    fill: "#f59c27"
  })));
}
export default SvgO;